'use client';

import React, { useState } from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { LoadingBall } from '@depop/web-ui-kit/LoadingBall';
import clsx from 'clsx';

import { AppleSignupButton } from '../AppleSignupButton';
import { EbaySignupButton } from '../EbaySignupButton';
import { GoogleSignupButton } from '../GoogleSignupButton';

import styles from './styles.module.css';

import { SSOButtonVariant } from '@/modules/auth/types';
import { ON_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

type Props = { ssoButtonVariant: SSOButtonVariant; nonce: string };

function SocialSignUp({ ssoButtonVariant, nonce }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [errorText, setError] = useState('');
  const { web_9278_ebay_sso } = useExperiments(['web_9278_ebay_sso']);
  const isEbaySSOEnabled = web_9278_ebay_sso === ON_IDENTIFIER;

  const isEyeCatchingVariant =
    ssoButtonVariant === SSOButtonVariant.EyeCatching;

  return (
    <>
      {errorText && (
        <Caption variant="lg-regular" className={styles.errorText}>
          {errorText}
        </Caption>
      )}
      {isLoading && <LoadingBall className={styles.loader} />}
      <div
        className={clsx(
          isEyeCatchingVariant ? styles.rowWrapper : styles.columnWrapper
        )}
      >
        <GoogleSignupButton
          setError={setError}
          setIsLoading={setIsLoading}
          ssoButtonVariant={ssoButtonVariant}
          nonce={nonce}
        />
        {isEbaySSOEnabled && <EbaySignupButton />}
        <AppleSignupButton
          setError={setError}
          setIsLoading={setIsLoading}
          ssoButtonVariant={ssoButtonVariant}
        />
      </div>
    </>
  );
}

export { SocialSignUp };
